import React, { useState, useEffect, useRef } from "react";
import "../countries-css/chart_content.css";
import bottleImage from "../../../../../../assets/conserve-water-chart-05-image-01.webp";

const Chart = () => {
  const [waterPercentage, setWaterPercentage] = useState(0);
  const chartSectionRef = useRef(null);

  useEffect(() => {
    const chartSectionNode = chartSectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timer = setTimeout(() => {
              const waterHeight = (15 / 100) * 200;
              setWaterPercentage(waterHeight);
            }, 300);

            return () => clearTimeout(timer);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (chartSectionNode) {
      observer.observe(chartSectionNode);
    }

    return () => {
      if (chartSectionNode) {
        observer.unobserve(chartSectionNode);
      }
    };
  }, []);

  return (
    <div className="conserve-waste-chart-05-section" ref={chartSectionRef}>
      <div className="conserve-waste-chart-05-container">
        <img className="conserve-waste-chart-05-image" src={bottleImage} alt="Bottle" />
        <div className="conserve-waste-chart-05-container-content-02">
          <div className="conserve-waste-chart-05-image-water-effect-02" style={{ height: waterPercentage }} />
        </div>
      </div>
    </div>
  );
};

export default Chart;
